import React, {useCallback, useEffect} from 'react';
import {useRechargeStore} from '../recharge.store';
import './recharge-tab.css';
import {
  ActivityPay,
  getActivityPayList,
  // RechargeTabApiRule,
} from './recharge-tab.service';
import theme from '@/style';

// Props接口（可选，用于外部控制）
export interface RechargeTabProps {
  onTabChange?: (tabId: number) => void;
  loading?: boolean;
}

const RechargeTab: React.FC<RechargeTabProps> = ({
  onTabChange,
  loading: externalLoading,
}) => {
  // 从store获取状态
  const {
    tabs,
    activeTabId,
    loading: storeLoading,
    setActiveTabId,
    setTabs,
  } = useRechargeStore();

  // 使用外部loading或store loading
  const loading =
    externalLoading !== undefined ? externalLoading : storeLoading;

  // // 背景图映射
  // const checkmarkImages: Record<number, any> = {
  //   1: require('@/assets/imgs/recharge/01-1.webp'),
  //   2: require('@/assets/imgs/recharge/02-1.webp'),
  //   3: require('@/assets/imgs/recharge/03-1.webp'),
  //   4: require('@/assets/imgs/recharge/04-1.webp'),
  //   5: require('@/assets/imgs/recharge/05-1.webp'),
  //   6: require('@/assets/imgs/recharge/06-1.webp'),
  //   7: require('@/assets/imgs/recharge/07-1.webp'),
  //   8: require('@/assets/imgs/recharge/08-1.webp'),
  //   9: require('@/assets/imgs/recharge/09-1.webp'),
  //   10: require('@/assets/imgs/recharge/10-1.webp'),
  // };

  // 处理tab点击
  const handleTabPress = useCallback(
    (tabId: number) => {
      setActiveTabId(tabId);
      // 更新store中的tab选中状态
      const {updateTabActiveStatus} = useRechargeStore.getState();
      updateTabActiveStatus(tabId, true);
      onTabChange?.(tabId);
    },
    [setActiveTabId, onTabChange],
  );

  useEffect(() => {
    init();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const init = async () => {
    const res = await getActivityPayList();
    setTabs(res);
  };

  if (tabs.length === 0) {
    return null;
  }

  // 渲染单个tab
  const renderTab = (tab: ActivityPay, index: number) => {
    const isSelected = activeTabId === tab.id;
    const name = tab.aliasName || tab.name;

    return (
      <div
        key={tab.id + index}
        className={`relative flex flex-col justify-center items-center rounded-[8px] cursor-pointer w-full  h-full overflow-hidden ${
          isSelected && 'border-c1 border-[2px]'
        }`}
        onClick={() => handleTabPress(tab.id)}>
        {/* 背景图 - 使用后台传入的 payDisplayImg */}
        {tab?.payDisplayImg && (
          <img
            src={tab.payDisplayImg}
            alt={`Background ${tab.id}`}
            className="absolute inset-0 w-full h-full"
          />
        )}

        {/* 主要内容区域 */}
        <div className="relative flex flex-col justify-center  flex-1 w-full px-2 gap-[2px]">
          {tab?.cornerMarkValue && (
            // 背景图tag.webp
            <div className='absolute top-2 left-2 bg-[url("@/assets/imgs/recharge/tag.webp")] bg-cover bg-left w-[4.9375rem]  flex px-[0.375rem] py-[0.25rem]'>
              <div className="text-[1.375rem] font-black leading-[87.6%] bg-gradient-to-b from-white to-[#FE0] bg-clip-text text-transparent">
                {tab.cornerMarkValue}
              </div>
            </div>
          )}
          {/* 如果没有tab?.cornerMarkValue ，则name 就垂直居中 */}
          {/* 文案内容 */}
          {name && (
            <div
              className={` w-[4.9375rem] flex flex-col items-start gap-[2px] ${
                tab?.cornerMarkValue
                  ? 'absolute top-10 left-2'
                  : 'top-1/2 left-1/2 '
              }`}>
              <span className="text-[0.625rem] font-bold leading-[0.625rem] text-white">
                {name}
              </span>
              <span className="text-[0.5rem] font-inter text-white leading-[0.5rem]">
                Bonus
              </span>
            </div>
          )}
        </div>

        {/* 选中状态指示器 */}
        {isSelected && (
          <div className="absolute -right-px -bottom-px">
            <svg className="w-5 h-5" viewBox="0 0 20 20" fill="none">
              <path
                d="M10 10L20 0V16C20 18.2091 18.2091 20 16 20H0L10 10Z"
                fill={theme.basicColor.primary}
              />
              <path
                d="M11.0003 13.6667L12.9263 15.7407L16.667 12"
                stroke={theme.basicColor.white}
                strokeWidth="1.33333"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </div>
        )}
      </div>
    );
  };

  if (loading) {
    return (
      <div className="flex justify-center items-center h-32">
        <span className="recharge-tab-loading text-gray-500">Loading...</span>
      </div>
    );
  }

  return (
    <div className="recharge-tab-scroll overflow-x-auto no-scrollbar">
      <div className="flex gap-2">
        {tabs.map((tab, index) => (
          <div key={tab.id} className="flex-shrink-0 w-[8.8125rem] h-[5rem]">
            {renderTab(tab, index)}
          </div>
        ))}
      </div>
    </div>
  );
};

export default RechargeTab;
